// src/app/shared/utils/global-message.util.ts
import { MessageService } from 'primeng/api';

export class GlobalMessageUtil {
  private static messageService: MessageService;
  private static readonly DEFAULT_KEY = 'main';

  public static init(messageService: MessageService) {
    GlobalMessageUtil.messageService = messageService;
  }

  public static error(summary: string, detail: string, life = 3000) {
    GlobalMessageUtil.messageService?.add({
      severity: 'error',
      summary,
      detail,
      life,
      key: GlobalMessageUtil.DEFAULT_KEY,
    });
  }

  public static warn(summary: string, detail: string, life = 3000) {
    GlobalMessageUtil.messageService?.add({
      severity: 'warn',
      summary,
      detail,
      life,
      key: GlobalMessageUtil.DEFAULT_KEY,
    });
  }

  public static success(summary: string, detail: string, life = 3000) {
    GlobalMessageUtil.messageService?.add({
      severity: 'success',
      summary,
      detail,
      life,
      key: GlobalMessageUtil.DEFAULT_KEY,
    });
  }

  public static clear(key?: string) {
    GlobalMessageUtil.messageService?.clear(key);
  }
}
